import { useState, useEffect } from "react";
import { MdOutlineAdd, MdDelete } from "react-icons/md";

import Input from ".";
import SelectInput from "./selectInput";

const ArrayInput2 = ({ schema, uischema, onChangeFunc, initialData = [] }) => {
  const [items, setItems] = useState([{}]);
  const properties = schema?.items?.properties;

  useEffect(() => {
    // console.log(initialData)
    // let newData = initialData.map((element) => ({
    //   group: element.Group,
    //   amount: element.Amount,
    //   currency: element.Currency,
    // }));
    if (schema?.name === "Price Group") {
      setItems(initialData);
    } else if (schema?.name === "Payment Plan") {
      let newData = initialData.map((element) => ({
        installment: element.Installment,
        percentage: element.Percentage,
      }));
      setItems(newData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addItem = () => {
    setItems([...items, {}]);
  };

  const removeItem = (index) => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
    onChangeFunc(newItems);
  };

  const mapOptions = (options, key) => {
    return options.map((element) => {
      if (key === "currency") {
        return { label: element, value: element.split(" - ")[0] };
      } else if (key === "installment") {
        return { label: element, value: element.replace(" ", "") };
      } else {
        return { label: element, value: element.toLowerCase() };
      }
    });
  };

  const handleChange = (index, key, value) => {
    console.log(`before `);
    console.log(items);
    const newItems = [...items];
    newItems[index] = { ...newItems[index], [key]: value };
    console.log(newItems);

    setItems(newItems);
    onChangeFunc(newItems);
  };

  const capitalizeFirstLetter = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <div className="p-3 border border-gray-300 rounded my-3">
      <div className="flex justify-between items-center">
        <div className="font-bold">{schema?.name}</div>
        <button
          onClick={addItem}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          <MdOutlineAdd />
        </button>
      </div>

      {items.map((item, index) => (
        <div
          key={index}
          className="flex space-x-2 mx-3 mt-4 p-3 border border-gray-300 rounded relative"
        >
          {items.length > 1 && (
            <button
              onClick={() => removeItem(index)}
              className="absolute top-0 right-0 bg-red-500 text-white px-2 py-1 rounded hover:bg-red-700"
            >
              <MdDelete />
            </button>
          )}
          {properties &&
            Object.entries(properties).map(([key, value]) => (
              <div key={key} className="flex-1">
                {value?.type === "string" && !value?.enum && (
                  <div>
                    <div>{capitalizeFirstLetter(key)}</div>
                    <div>
                      <Input
                        label={key}
                        name={`${key}-${index}`}
                        value={item[key] || ""}
                        data={item[key] || ""}
                        onChange={(e) => handleChange(index, key, e)}
                      />
                    </div>
                  </div>
                )}
                {value?.type === "string" && value?.enum && (
                  <div>
                    <div>{capitalizeFirstLetter(key)}</div>
                    <div>
                      <SelectInput
                        label={key}
                        name={`${key}-${index}`}
                        options={mapOptions(value?.enum, key)}
                        className="!h-16"
                        value={item[key] || ""}
                        data={item[key] || ""}
                        onChange={(selectedOption) =>
                          handleChange(index, key, selectedOption)
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
      ))}
    </div>
  );
};

export default ArrayInput2;
